module.exports = __webpack_public_path__ + "media/photo/solutions_lady-6d2f40bd.jpg";